import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { ArticuloSerie } from '../veninterfaces/articuloserie';
import { InvtrnkardexotrService } from '../venservicios/invtrnkardexotr.service';
import { InvTrnkardexotr } from '../veninterfaces/invtrnkardexotr';
import { MessageService } from 'primeng/api';
import { AggridBanComponent } from '../../ban/aggrid-ban/aggrid-ban.component';
import { DatePipe } from '@angular/common';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';//CDPJ
import { isNullOrUndefined } from 'util';
import { CellListaEditorComponent } from "../../advantage/config/cell-lista-editor";
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';


@Component({
  selector: 'app-invtrnkardexotr',
  templateUrl: './invtrnkardexotr.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class InvtrnkardexotrComponent implements OnInit, OnChanges {
  // @ts-ignore
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  @ViewChild('inputFile') inputfile: ElementRef
  @Input() strNumFact: any;
  @Input() strNumFactDev: any;
  @Input() strFechaSer: any;
  @Input() strTipoDoc: any;
  @Input() strTipoTrn: any;
  @Input() devBoolean: any;
  @Input() strnBodega: any;//CDPJ
  @Input() strnBoddestino: any//CDPJ
  @Input() CNCANRECTR: any
  @Input() SoloVer: any
  @Input() PERELISER: number
  @Output() cerrar = new EventEmitter<boolean>();
  largo: string;
  largo2: string;
  selectAll: boolean;

  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;
  barraBotones2: boolean;
  datosArray = []
  strBodDestino: string;
  strBodOrigen: string;
  newtrow: boolean
  tabladetalle: ArticuloSerie[];
  detalleseleccionado: ArticuloSerie;

  tablaseriales: InvTrnkardexotr[];
  serialseleccionado: InvTrnkardexotr;

  listaseriales: InvTrnkardexotr[];

  bolvalidarDatos: boolean;
  spin = false;
  rowSelection = 'multiple';
  public frameworkComponents;
  rowStyle;
  defaultColDefDetalle;
  defaultColDefSeriales;
  claveDialog: boolean;
  claveAuth: string;
  displayDialogRazon: boolean
  razoneliserr: string

  columnDefsDetalle = [
    { // 0
      headerName: 'Bod.', field: 'BODCODIGO', width: 80, editable: false
    }, { // 1
      headerName: 'Artículo', field: 'ARTCODIGO', width: 130, editable: false
    }, { // 2
      headerName: 'Cant.', field: 'ARTCANTIDAD', width: 70, editable: false
    }, { // 3
      headerName: 'Nombre', field: 'ARTNOMBRE', width: 170, editable: false
    }];

  columnDefsSeriales = [
    {
      headerName: '',
      field: 'SELECCIONADO',
      cellRendererFramework: AggridBanComponent,
      editable: false,
      width: 50,
      onCellClicked: (params) => {
        this.docSeleccionado(params);
      }
    },

    { // 0
      headerName: 'Serie', field: 'TRNKARDEXOTR_NUMSERIE', cellEditor: 'cellPrueba', width: 150,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 30,
          tienecalculos: true,
          nextrow: true
        }
      }
    }, { // 1
      headerName: 'SIM', field: 'TRNKARDEXOTR_DIM', cellEditor: 'cellPrueba', width: 110,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          clave: false,
          tamanocelda: 20
        }
      }
    }, { // 2
      headerName: 'Teléfono', field: 'TRNKARDEXOTR_TELEFONO', cellEditor: 'cellPrueba', width: 110,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          clave: false,
          tamanocelda: 20
        }
      }
    },
    { // 3
      headerName: 'Color', field: 'TRNKARDEXOTR_COLOR', cellEditor: 'cellLista', width: 110,

      cellEditorParams: {
        values: []
      }

    },
    { // 4
      headerName: 'Bateria', field: 'TRNKARDEXOTR_PORCEBAT', cellEditor: 'cellPrueba', width: 110,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          clave: false,
          tamanocelda: 3
        }
      }
    },
  ];

  constructor(public trnkardexotrservice: InvtrnkardexotrService, private messageService: MessageService, private datePipe: DatePipe,
    private auditoriagral: AuditoriagralService,
    private uitilitariosService:UtilitariosService
    ) {
    this.agTable();
    this.devBoolean = false;
  }

  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba,
      cellLista: CellListaEditorComponent
    };

    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };

    this.defaultColDefDetalle = {
      editable: true,
      width: 80,
      objeto: 'tabladetalle'
    };

    this.defaultColDefSeriales = {
      editable: true,
      width: 80,
      objeto: 'tablaseriales'
    };
  }

  async ngOnInit() {
    this.largo = '650';
    this.largo2 = '600';
    this.selectAll = false;
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = true;
    this.botonRegresar = true;
    this.barraBotones2 = true;
    this.newtrow = false
    this.claveAuth = '';
    this.claveDialog = false;
    const [data, lista] = await Promise.all([await this.trnkardexotrservice.obtenerConfiguracion(), await this.trnkardexotrservice.consultarcolores()])

    if (data !== null) {
      this.newtrow = data[0].CFG_VALOR1 === 1;
      this.columnDefsSeriales[0].cellEditorParams = {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 30,
          tienecalculos: true,
          nextrow: this.newtrow
        }
      };

    } else {
      this.newtrow = false;
      this.columnDefsSeriales[0].cellEditorParams = {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 30,
          tienecalculos: true,
          nextrow: this.newtrow
        }
      };

    }
    if (this.devBoolean === false) {

      const opciones = [];

      this.columnDefsSeriales = [
        { // 0
          headerName: 'Serie', field: 'TRNKARDEXOTR_NUMSERIE', cellEditor: 'cellPrueba', width: 150,
          cellEditorParams:
          {
            values: {
              mayusculas: true,
              numeros: true,
              alphabetic: true,
              saltoslinea: 1,
              newrow: false,
              numerodecimales: 0,
              obligatorio: true,
              fecha: false,
              clave: false,
              tamanocelda: 30,
              tienecalculos: true,
              nextrow: this.newtrow
            }
          }
        }, { // 1
          headerName: 'SIM', field: 'TRNKARDEXOTR_DIM', cellEditor: 'cellPrueba', width: 110,
          cellEditorParams:
          {
            values: {
              mayusculas: true,
              numeros: true,
              alphabetic: true,
              saltoslinea: 1,
              newrow: false,
              numerodecimales: 0,
              obligatorio: false,
              fecha: false,
              clave: false,
              tamanocelda: 20
            }
          }
        }, { // 2
          headerName: 'Teléfono', field: 'TRNKARDEXOTR_TELEFONO', cellEditor: 'cellPrueba', width: 110,
          cellEditorParams:
          {
            values: {
              mayusculas: true,
              numeros: true,
              alphabetic: true,
              saltoslinea: 1,
              newrow: false,
              numerodecimales: 0,
              obligatorio: false,
              fecha: false,
              clave: false,
              tamanocelda: 20
            }
          }
        },
        { // 3
          headerName: 'Color', field: 'TRNKARDEXOTR_COLOR', cellEditor: 'cellLista', width: 110,

          cellEditorParams: {
            values: []
          }
        },
        { // 4
          headerName: 'Bateria', field: 'TRNKARDEXOTR_PORCEBAT', cellEditor: 'cellPrueba', width: 110,
          cellEditorParams:
          {
            values: {
              mayusculas: false,
              numeros: true,
              alphabetic: false,
              saltoslinea: 1,
              newrow: false,
              numerodecimales: 0,
              obligatorio: false,
              fecha: false,
              clave: false,
              tamanocelda: 3,

            }
          }
        },
      ];
      if (lista !== null && Object.keys(lista)) {
        lista.map((codigo) => {
          //if (codigo.TRNKARDEXOTR_COLOR !== opciones[0]) {
          opciones.push(codigo.TRNKARDEXOTR_COLOR);
          //}
        });
        this.columnDefsSeriales[3].cellEditorParams = {
          values: opciones
        };


      }
      this.agTable();
    } else {

      const opciones = [];
      if (lista !== null && Object.keys(lista)) {
        lista.map((codigo) => {
          //if (codigo.TRNKARDEXOTR_COLOR !== opciones[0]) {
          opciones.push(codigo.TRNKARDEXOTR_COLOR);
          //}
        });
        this.columnDefsSeriales[4].cellEditorParams = {
          values: opciones
        };

        this.agTable();
      }
    }


    this.tabladetalle = [];
    this.detalleseleccionado = {};
    this.trnkardexotrservice.tablaseriales = [];
    this.serialseleccionado = {};
    setTimeout(() => {
      this.aggrid.refreshColumnDefs()
      this.mostrarDetalle();
    }, 400);

  }

  async ngOnChanges(changes: SimpleChanges) {
    console.log('entro change', changes)
    for (const e in changes) {
      if (e === 'strNumFact' && this.strNumFact !== null) {
        this.newtrow = false
        this.claveAuth = '';
        this.claveDialog = false;
        const opciones = [];
        const [data, lista] = await Promise.all([await this.trnkardexotrservice.obtenerConfiguracion(), await this.trnkardexotrservice.consultarcolores()])
        if (data !== null) {

          this.newtrow = data[0].CFG_VALOR1 === 1;
          this.columnDefsSeriales[0].cellEditorParams = {
            values: {
              mayusculas: true,
              numeros: true,
              alphabetic: true,
              saltoslinea: 1,
              newrow: false,
              numerodecimales: 0,
              obligatorio: true,
              fecha: false,
              clave: false,
              tamanocelda: 30,
              tienecalculos: true,
              nextrow: this.newtrow
            }
          };

        } else {
          this.newtrow = false;
          this.columnDefsSeriales[0].cellEditorParams = {
            values: {
              mayusculas: true,
              numeros: true,
              alphabetic: true,
              saltoslinea: 1,
              newrow: false,
              numerodecimales: 0,
              obligatorio: true,
              fecha: false,
              clave: false,
              tamanocelda: 30,
              tienecalculos: true,
              nextrow: this.newtrow
            }
          };

        }
        if (lista !== null && Object.keys(lista)) {
          lista.map((codigo) => {
            //if (codigo.TRNKARDEXOTR_COLOR !== opciones[0]) {
            opciones.push(codigo.TRNKARDEXOTR_COLOR);
            //}
          });
          this.columnDefsSeriales[3].cellEditorParams = {
            values: opciones
          };


        }
        setTimeout(() => {
          this.aggrid.refreshColumnDefs()
          this.mostrarDetalle();
        }, 400);
      }
    }
  }

  mostrarDetalle() {
    this.tabladetalle = [];
    this.detalleseleccionado = {};
    this.trnkardexotrservice.tablaseriales = [];
    this.serialseleccionado = {};
    this.trnkardexotrservice.consultarArtículos(this.strTipoDoc, this.strNumFact).subscribe(async res => {

      //opciones.push(this.detfacSelected.DETFAC_LISTA);


      const listadetalle = [];
      for (const rs of res) {
        const data: ArticuloSerie = {};
        let i = 0;
        for (const rsin in rs) {
          if (i === 0) {
            data.BODCODIGO = rs[rsin];
            //CDPJ
            if (this.strTipoDoc === 'TRF') {
              data.BODCODIGO = this.strnBodega;
            }
            //CDPJ
          }
          if (i === 1) {
            data.ARTCODIGO = rs[rsin];
          }
          if (i === 2) {
            data.ARTNOMBRE = rs[rsin];
          }
          if (i === 3) {
            data.ARTCANTIDAD = rs[rsin];
          }
          if (i === 4) {
            data.NUMLINEA = rs[rsin];
          }

          i++;
        }
        console.log(rs)
        if (isNullOrUndefined(rs.NUMLINEAFAC) === false) {
          data.NUMLINEAFAC = rs.NUMLINEAFAC
        }
        listadetalle.push(data);
        this.detalleseleccionado = data
      }
      this.tabladetalle = listadetalle;
      this.aggrid.refreshaggrid(this.tabladetalle, this.defaultColDefDetalle.objeto);

    });
  }

  async manejarSenales(valor) {
    if (valor === 'Guardar') {
      this.spin = true
      this.botonGuardar = true
      this.guardarRegistro();
    }

    if (valor === 'Borrar') {
      // let val=0;
      // if (this.strTipoDoc === 'TRF') {
      //   val=this.serialseleccionado.TRNKARDEXOTR_NUMERO.toString().indexOf('_SA');
      //   if(val === -1) {
      //     this.serialseleccionado.TRNKARDEXOTR_NUMERO=this.serialseleccionado.TRNKARDEXOTR_NUMERO+'_SA';
      //     console.log(this.tablaseriales);
      //   }
      // }
      if (this.PERELISER === 1) {

        this.claveAuth = '';
        this.claveDialog = true;
        return
      }
      if (this.serialseleccionado.NUMLINEA) {
        const intIndiceFila = this.trnkardexotrservice.tablaseriales.findIndex(distri =>
          distri.CLAVE === this.serialseleccionado.CLAVE);
        this.trnkardexotrservice.tablaseriales.splice(intIndiceFila, 1);
        this.aggrid.refreshaggrid(this.trnkardexotrservice.tablaseriales, this.defaultColDefSeriales.objeto);
        return
      }
      if (this.strTipoDoc === 'FACPRO' || this.strTipoDoc === 'NOTREC'
        || this.strTipoDoc === 'INVENT') {
        let intExistencia = 0;
        const res1 = await this.trnkardexotrservice.esExisteSerialSal(this.serialseleccionado.TRNKARDEXOTR_NUMSERIE, this.serialseleccionado.ART_CODIGO, this.serialseleccionado.BOD_CODIGO).toPromise()
        if (res1 !== null) {
          for (const rs of res1) {
            intExistencia = rs.SERIAL;
          }
        }
        if (intExistencia === 1) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'El Número de Serie ya Existe en una salida.'
          });
          this.spin = false
          return;
        }

        this.trnkardexotrservice.eliminarKardexOtr(this.serialseleccionado).subscribe(data => {
          this.messageService.add({
            key: 'seriales',
            severity: 'success',
            summary: 'Información',
            detail: 'Serial Eliminado'
          });
          this.mostrarDetalle();
          this.habilitarBotones(true, true, false, true);

        });
        //CDPJ
        this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTR_' +
          this.strTipoDoc, this.serialseleccionado.TRNKARDEXOTR_NUMERO.toString() +
          '/' + this.serialseleccionado.ART_CODIGO + '/' + this.serialseleccionado.TRNKARDEXOTR_NUMSERIE, 'E',
          '', '01', '', '', '', '').subscribe();
        //CDPJ
        if (this.strTipoDoc === 'TRF') {
          this.serialseleccionado.TRNKARDEXOTR_NUMERO = this.serialseleccionado.TRNKARDEXOTR_NUMERO.toString().replace('_SA', '');
          this.serialseleccionado.TRNKARDEXOTR_TIPO = 'EN'
          this.trnkardexotrservice.eliminarKardexOtr(this.serialseleccionado).subscribe(data => {
            this.messageService.add({
              key: 'seriales',
              severity: 'success',
              summary: 'Información',
              detail: 'Serial Eliminado'
            });

            this.mostrarDetalle();
            this.habilitarBotones(true, true, false, true);
          });
          //CDPJ
          this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTR_' + this.strTipoDoc,
            this.serialseleccionado.TRNKARDEXOTR_NUMERO.toString() +
            '/' + this.serialseleccionado.ART_CODIGO + '/' + this.serialseleccionado.TRNKARDEXOTR_NUMSERIE, 'E',
            '', '01', '', '', '', '').subscribe();
          //CDPJ
        }

      } else {
        this.trnkardexotrservice.eliminarKardexOtr(this.serialseleccionado).subscribe(data => {
          this.messageService.add({
            key: 'seriales',
            severity: 'success',
            summary: 'Información',
            detail: 'Serial Eliminado'
          });
          this.mostrarDetalle();
          this.habilitarBotones(true, true, false, true);

        });
        //CDPJ
        this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTR_' +
          this.strTipoDoc, this.serialseleccionado.TRNKARDEXOTR_NUMERO.toString() +
          '/' + this.serialseleccionado.ART_CODIGO + '/' + this.serialseleccionado.TRNKARDEXOTR_NUMSERIE, 'E',
          '', '01', '', '', '', '').subscribe();
        //CDPJ
        if (this.strTipoDoc === 'TRF') {
          this.serialseleccionado.TRNKARDEXOTR_NUMERO = this.serialseleccionado.TRNKARDEXOTR_NUMERO.toString().replace('_SA', '');
          this.serialseleccionado.TRNKARDEXOTR_TIPO = 'EN'
          this.trnkardexotrservice.eliminarKardexOtr(this.serialseleccionado).subscribe(data => {
            this.messageService.add({
              key: 'seriales',
              severity: 'success',
              summary: 'Información',
              detail: 'Serial Eliminado'
            });

            this.mostrarDetalle();
            this.habilitarBotones(true, true, false, true);
          });
          //CDPJ
          this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTR_' + this.strTipoDoc,
            this.serialseleccionado.TRNKARDEXOTR_NUMERO.toString() +
            '/' + this.serialseleccionado.ART_CODIGO + '/' + this.serialseleccionado.TRNKARDEXOTR_NUMSERIE, 'E',
            '', '01', '', '', '', '').subscribe();
          //CDPJ
        }
      }

    }

    if (valor === 'Cancelar') {
      this.mostrarDetalle();
      this.habilitarBotones(true, true, false, true);
    }

    if (valor === 'Salir') {
      this.cerrar.emit(true);
    }


  }
  comprobarClave() {
    this.trnkardexotrservice.obtenerClave('ELISER').subscribe((clave) => {
      let claveReal;
      claveReal = clave[0].AUTORIZACION_CLAVE;
      if (claveReal === this.claveAuth) {
        this.displayDialogRazon = true;
        this.razoneliserr = '';
        this.claveAuth = '';
        this.claveDialog = false;
      }
    });
  }
  eliminarSer() {
    let strRazon = this.razoneliserr;
    if (strRazon === null || strRazon === undefined) {
      strRazon = '';
    }

    if (strRazon.length === 0) {
      this.messageService.add({
        key: 'seriales',
        severity: 'warn',
        summary: 'Información',
        detail: 'Para eliminar el serial se debe ingresar la razón.'
      });
      return;
    }
    this.elimnarreg();
  }
  cancelarSer() {
    this.displayDialogRazon = false;
    this.razoneliserr = '';
  }
  elimnarreg() {
    this.displayDialogRazon = false;

    if (this.serialseleccionado.NUMLINEA) {
      const intIndiceFila = this.trnkardexotrservice.tablaseriales.findIndex(distri =>
        distri.CLAVE === this.serialseleccionado.CLAVE);
      this.trnkardexotrservice.tablaseriales.splice(intIndiceFila, 1);
      this.aggrid.refreshaggrid(this.trnkardexotrservice.tablaseriales, this.defaultColDefSeriales.objeto);
      return
    }
    this.trnkardexotrservice.eliminarKardexOtr(this.serialseleccionado).subscribe(data => {
      this.messageService.add({
        key: 'seriales',
        severity: 'success',
        summary: 'Información',
        detail: 'Serial Eliminado'
      });
      this.mostrarDetalle();
      this.habilitarBotones(true, true, false, true);

    });
    //CDPJ
    this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTR_' +
      this.strTipoDoc, this.serialseleccionado.TRNKARDEXOTR_NUMERO.toString() +
      '/' + this.serialseleccionado.ART_CODIGO + '/' + this.serialseleccionado.TRNKARDEXOTR_NUMSERIE + '/RAZON:' + this.razoneliserr, 'E',
      '', '01', '', '', '', '').subscribe();
    //CDPJ
    if (this.strTipoDoc === 'TRF') {
      this.serialseleccionado.TRNKARDEXOTR_NUMERO = this.serialseleccionado.TRNKARDEXOTR_NUMERO.toString().replace('_SA', '');
      this.serialseleccionado.TRNKARDEXOTR_TIPO = 'EN'
      this.trnkardexotrservice.eliminarKardexOtr(this.serialseleccionado).subscribe(data => {
        this.messageService.add({
          key: 'seriales',
          severity: 'success',
          summary: 'Información',
          detail: 'Serial Eliminado'
        });

        this.mostrarDetalle();
        this.habilitarBotones(true, true, false, true);
      });
      //CDPJ
      this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTR_' + this.strTipoDoc,
        this.serialseleccionado.TRNKARDEXOTR_NUMERO.toString() +
        '/' + this.serialseleccionado.ART_CODIGO + '/' + this.serialseleccionado.TRNKARDEXOTR_NUMSERIE + '/RAZON:' + this.razoneliserr, 'E',
        '', '01', '', '', '', '').subscribe();
      //CDPJ
    }
  }
  cambio(cambio) {
    if (this.SoloVer === true) {
      return
    }
    if (cambio === true) {
      this.habilitarBotones(false, true, false, true);
    }
  }

  selecciondetalle(params) {
    if (params.object === undefined) {
      return;
    }

    this.detalleseleccionado = params.object;
    console.log(this.detalleseleccionado)
    this.mostrarSerialesGrilla(this.strTipoDoc, this.detalleseleccionado);
  }

  seleccionseriales(params) {
    if (params.object === undefined) {
      return;
    }
    if (this.SoloVer === true) {
      return;
    }
    this.serialseleccionado = params.object;
    this.habilitarBotones(this.botonGuardar, false, false, false);
  }
  docSeleccionado(params) {
    console.log(params.data)
    if (params.data.SELECCIONADO) {
      this.habilitarBotones(false, true, false, false);
    }
  }
  subirArchivo() {
    //const inputFile= document.querySelector<HTMLInputElement>("#inputFile")
    //if (inputFile) {
    if (this.SoloVer === true) {
      return
    }
    this.inputfile.nativeElement.click()
    //}
  }
  // onFileSelected(event) {
  //   const input = event.target as HTMLInputElement
  //   let repetir = 0;
  //   if (input.files && input.files.length > 0) {
  //     const file = input.files[0];
  //     const reader = new FileReader()
  //     reader.onload = (e: ProgressEvent<FileReader>) => {
  //       const contenido = e.target?.result as string
  //       this.datosArray = contenido.split('\n').map(linea => linea.trim()).filter(linena => linena.length > 0);
  //       const ocurrencias: { [key: string]: number } = {};
  //       this.datosArray.forEach(valor => {
  //         ocurrencias[valor] = (ocurrencias[valor] || 0) + 1
  //       })
  //       Object.keys(ocurrencias).forEach(valor => {
  //         if (ocurrencias[valor] > 1) {
  //           this.messageService.add({
  //             key: 'seriales',
  //             severity: 'warn',
  //             summary: 'Información',
  //             detail: `El serial ${valor} se encuentra repetido.`
  //           });
  //           repetir++;
  //         }
  //       })
  //       if (repetir === 0) {
  //         const filaseleccionada = this.detalleseleccionado
  //         this.listaseriales = [];
  //         let intNumLinea = 0;
  //         const strNumDoc = this.strNumFact;
  //         const strTipoTrn = this.strTipoTrn;
  //         const artcodigo = filaseleccionada.ARTCODIGO;
  //         const bodcodigo = filaseleccionada.BODCODIGO;
  //         const cantidad = filaseleccionada.ARTCANTIDAD;
  //         const strTipoDoc = this.strTipoDoc
  //         intNumLinea = filaseleccionada.NUMLINEA;
  //         this.cambio(true)
  //         this.crearNuevosSeriales(this.datosArray.length, strNumDoc, strTipoTrn, bodcodigo, artcodigo, strTipoDoc,
  //           intNumLinea)
  //       }
  //       this.inputfile.nativeElement.value = ''
  //     }
  //     reader.readAsText(file)
  //   }
  // }
  onFileSelected(event) {
    const input = event.target as HTMLInputElement
    let repetir = 0
    let bateriaInvalida = false;

    if (input.files && input.files.length > 0) {
      const file = input.files[0]
      const reader = new FileReader();

      reader.onload = (e: ProgressEvent<FileReader>) => {
        const contenido = e.target?.result as string

        this.datosArray = contenido.split(/\r?\n/)
          .map(linea => linea.trim())
          .filter(linea => linea.length > 0)
          .map(linea => {
            const partes = linea.split(';');
            return {
              serial: partes[0]?.trim() || '',
              color: partes[1]?.trim() || '',
              bateria: partes[2]?.trim() || ''
            }
          });
        //Validar seriales repetidos

        const ocurrencias: { [key: string]: number } = {}
        this.datosArray.forEach(item => {

          const serial = item.serial;
          const bateria = item.bateria;

          if (serial) {
            ocurrencias[serial] = (ocurrencias[serial] || 0) + 1
          }
          if (bateria !== '') {
            const esEntero = /^\d+$/.test(bateria);
            const valor = Number(bateria);

            if (!esEntero || valor < 0 || valor > 100) {
              bateriaInvalida = true;
              this.messageService.add({
                key: 'seriales',
                severity: 'warn',
                summary: 'Información',
                detail: `El serial ${serial} tiene una bateria inválida (${bateria}). Debe ser un número entero entre 0 y 100`
              });
            }
          }
        });
        Object.keys(ocurrencias).forEach(serial => {
          if (ocurrencias[serial] > 1) {
            this.messageService.add({
              key: 'seriales',
              severity: 'warn',
              summary: 'Información',
              detail: `El serial ${serial} se encuentra repetido`
            });
            repetir++
          }
        })
        if (repetir === 0 && bateriaInvalida === false) {
          const filaseleccionada = this.detalleseleccionado
          this.listaseriales = []
          let intNumLinea = 0;
          const strNumDoc = this.strNumFact;
          const strTipoTrn = this.strTipoTrn;
          const artcodigo = filaseleccionada.ARTCODIGO;
          const bodcodigo = filaseleccionada.BODCODIGO;
          const cantidad = filaseleccionada.ARTCANTIDAD;
          const strTipoDoc = this.strTipoDoc;
          intNumLinea = filaseleccionada.NUMLINEA;

          this.cambio(true)

          this.crearNuevosSeriales(this.datosArray.length,
            strNumDoc,
            strTipoTrn,
            bodcodigo,
            artcodigo,
            strTipoDoc,
            intNumLinea)
        }
        this.inputfile.nativeElement.value = ''
      }
      reader.readAsText(file);
    }
  }
  mostrarSerialesGrilla(strTipoDoc, filaseleccionada) {
    let intNumSeriales = 0;
    let intNumLinea = 0;
    const strNumDoc = this.strNumFact;
    const strTipoTrn = this.strTipoTrn;

    const artcodigo = filaseleccionada.ARTCODIGO;
    const bodcodigo = filaseleccionada.BODCODIGO;
    const cantidad = filaseleccionada.ARTCANTIDAD;
    intNumLinea = filaseleccionada.NUMLINEA;
    this.datosArray = []
    if (strTipoDoc === 'FACPRO' || strTipoDoc === 'NOTREC') {
      this.trnkardexotrservice.consultarDetalle(artcodigo,
        strNumDoc, 'COM', intNumLinea).subscribe(res => {
          intNumSeriales = res.length;
          this.listaseriales = [];
          for (const item of res) {
            item.NUEVO = false
            item.TRNKARDEXOTR_PORCEBAT = isNullOrUndefined(item.TRNKARDEXOTR_PORCEBAT) ? '' : item.TRNKARDEXOTR_PORCEBAT
            this.listaseriales.push(item);
          }
          this.trnkardexotrservice.tablaseriales = this.listaseriales;
          // Si no hay seriales ingresados se crea las líneas en blanco para el
          // ingreso dependiendo de la cantidad
          if (intNumSeriales === 0) {
            this.crearNuevosSeriales(cantidad, strNumDoc, strTipoTrn,
              bodcodigo, artcodigo, strTipoDoc, intNumLinea);
          } else if (intNumSeriales < cantidad) {
            this.crearNuevosSeriales(cantidad - intNumSeriales,
              strNumDoc, strTipoTrn, bodcodigo, artcodigo, strTipoDoc,
              intNumLinea);
          }
        });
    } else {
      if (strTipoDoc === 'DVFCOM' || strTipoDoc === 'DVFVEN') {

        this.trnkardexotrservice.consultarDetalleDev(artcodigo, this.strNumFact, strTipoDoc, intNumLinea).subscribe((res) => {//SE BUSCA POR EL NUMERO DE LA DEVOLUCIÓN

          if (res.length > 0) {
            intNumSeriales = res.length;
            this.listaseriales = [];
            let i = 1
            for (const item of res) {
              item.TRNKARDEXOTR_ORIGEN = strTipoDoc;
              item.TRNKARDEXOTR_NUMERO = this.strNumFact;
              //item.TRNKARDEXOTR_NUMSEC = item.TRNKARDEXOTR_NUMSEC;
              item.TRNKARDEXOTR_TIPO = this.strTipoTrn;
              item.SELECCIONADO = true;
              item.TRNKARDEXOTR_LINEA = intNumLinea
              i++
              item.NUEVO = false
              item.TRNKARDEXOTR_PORCEBAT = isNullOrUndefined(item.TRNKARDEXOTR_PORCEBAT) ? '' : item.TRNKARDEXOTR_PORCEBAT
              this.listaseriales.push(item);
            }
            this.trnkardexotrservice.tablaseriales = this.listaseriales;
            // Si no hay seriales ingresados se crea las líneas en blanco para el
            // ingreso dependiendo de la cantidad
            // if (intNumSeriales === 0) {
            //   this.crearNuevosSeriales(cantidad, strNumDoc, strTipoTrn,
            //     bodcodigo, artcodigo, strTipoDoc, intNumLinea);
            // } else if (intNumSeriales < cantidad) {
            //   this.crearNuevosSeriales(intNumSeriales,
            //     strNumDoc, strTipoTrn, bodcodigo, artcodigo, strTipoDoc,
            //     intNumLinea);
            // }
          } else {
            this.trnkardexotrservice.consultarDetalleDevFac(artcodigo, this.strNumFactDev, strTipoDoc, filaseleccionada.NUMLINEAFAC).subscribe((res) => {//SE BUSCA POR EL NUMERO DE LA FACTURA
              console.log(res.length)
              if (res.length > 0) {
                intNumSeriales = res.length;
                this.listaseriales = [];
                for (const item of res) {
                  item.TRNKARDEXOTR_ORIGEN = strTipoDoc;
                  item.TRNKARDEXOTR_NUMERO = this.strNumFact;
                  item.TRNKARDEXOTR_NUMSEC = 0;
                  item.TRNKARDEXOTR_TIPO = this.strTipoTrn;
                  item.TRNKARDEXOTR_LINEA = intNumLinea
                  item.SELECCIONADO = false;
                  item.NUEVO = true
                  item.TRNKARDEXOTR_PORCEBAT = isNullOrUndefined(item.TRNKARDEXOTR_PORCEBAT) ? '' : item.TRNKARDEXOTR_PORCEBAT
                  this.listaseriales.push(item);
                }
                this.trnkardexotrservice.tablaseriales = this.listaseriales;
                // Si no hay seriales ingresados se crea las líneas en blanco para el
                // ingreso dependiendo de la cantidad
                if (intNumSeriales === 0) {
                  this.crearNuevosSeriales(cantidad, strNumDoc, strTipoTrn,
                    bodcodigo, artcodigo, strTipoDoc, intNumLinea);
                } else if (intNumSeriales < cantidad) {
                  this.crearNuevosSeriales(cantidad - intNumSeriales,
                    strNumDoc, strTipoTrn, bodcodigo, artcodigo, strTipoDoc,
                    intNumLinea);
                }
              } else {
                this.listaseriales = [];
                //console.log(cantidad)
                for (let fila = 1; fila <= cantidad; fila++) {

                  const item: InvTrnkardexotr = {};

                  item.TRNKARDEXOTR_NUMERO = strNumDoc;
                  item.TRNKARDEXOTR_NUMSEC = 0;
                  item.COM_CODIGO = '01';
                  item.TRNKARDEXOTR_TIPO = strTipoTrn;
                  item.BOD_CODIGO = bodcodigo;
                  item.ART_CODIGO = artcodigo;
                  item.TRNKARDEXOTR_NUMSERIE = '';
                  item.TRNKARDEXOTR_DIM = '';
                  item.TRNKARDEXOTR_TELEFONO = '';
                  item.TRNKARDEXOTR_ORIGEN = strTipoDoc;
                  item.TRNKARDEXOTR_LINEA = intNumLinea;
                  item.TRNKARDEXOTR_FECHATRN = '';
                  item.NUEVO = true;
                  item.SELECCIONADO = false;
                  item.TRNKARDEXOTR_PORCEBAT = ''
                  if (this.datosArray.length > 0) {
                    item.NUMLINEA = true
                    item.CLAVE = fila + this.datePipe.transform(new Date(), 'dd/MM/yyyy HH:mm:ss')
                  }

                  this.listaseriales.push(item);
                }
                this.trnkardexotrservice.tablaseriales = this.listaseriales;
                //console.log(this.listaseriales)
              }

            })
          }


        });




      } else if (strTipoDoc === 'TRF' && this.CNCANRECTR === 1) {
        this.trnkardexotrservice.consultarDetalleTrfTmp(artcodigo,
          this.strNumFact, strTipoDoc, intNumLinea).subscribe(res => {

            intNumSeriales = res.length;
            this.listaseriales = [];
            for (const item of res) {
              item.NUEVO = false
              item.TRNKARDEXOTR_PORCEBAT = isNullOrUndefined(item.TRNKARDEXOTR_PORCEBAT) ? '' : item.TRNKARDEXOTR_PORCEBAT
              this.listaseriales.push(item);
            }
            this.trnkardexotrservice.tablaseriales = this.listaseriales;
            // Si no hay seriales ingresados se crea las líneas en blanco para el
            // ingreso dependiendo de la cantidad
            if (intNumSeriales === 0) {
              this.trnkardexotrservice.consultarDetalle(artcodigo,
                this.strNumFact, strTipoDoc, intNumLinea).subscribe(res => {
                  intNumSeriales = res.length;
                  this.listaseriales = [];
                  for (const item of res) {
                    item.NUEVO = false
                    item.TRNKARDEXOTR_PORCEBAT = isNullOrUndefined(item.TRNKARDEXOTR_PORCEBAT) ? '' : item.TRNKARDEXOTR_PORCEBAT
                    this.listaseriales.push(item);
                  }
                  this.trnkardexotrservice.tablaseriales = this.listaseriales;
                  // Si no hay seriales ingresados se crea las líneas en blanco para el
                  // ingreso dependiendo de la cantidad
                  if (intNumSeriales === 0) {
                    this.crearNuevosSeriales(cantidad, strNumDoc, strTipoTrn,
                      bodcodigo, artcodigo, strTipoDoc, intNumLinea);
                  } else if (intNumSeriales < cantidad) {
                    this.crearNuevosSeriales(cantidad - intNumSeriales,
                      strNumDoc, strTipoTrn, bodcodigo, artcodigo, strTipoDoc,
                      intNumLinea);
                  }
                });
            } else if (intNumSeriales < cantidad) {
              this.crearNuevosSeriales(cantidad - intNumSeriales,
                strNumDoc, strTipoTrn, bodcodigo, artcodigo, strTipoDoc,
                intNumLinea);
            }

          });
      } else {
        this.trnkardexotrservice.consultarDetalle(artcodigo,
          this.strNumFact, strTipoDoc, intNumLinea).subscribe(res => {
            intNumSeriales = res.length;
            this.listaseriales = [];
            for (const item of res) {
              item.NUEVO = false
              item.TRNKARDEXOTR_PORCEBAT = isNullOrUndefined(item.TRNKARDEXOTR_PORCEBAT) ? '' : item.TRNKARDEXOTR_PORCEBAT
              this.listaseriales.push(item);
            }
            this.trnkardexotrservice.tablaseriales = this.listaseriales;
            // Si no hay seriales ingresados se crea las líneas en blanco para el
            // ingreso dependiendo de la cantidad
            if (intNumSeriales === 0) {
              this.crearNuevosSeriales(cantidad, strNumDoc, strTipoTrn,
                bodcodigo, artcodigo, strTipoDoc, intNumLinea);
            } else if (intNumSeriales < cantidad) {
              this.crearNuevosSeriales(cantidad - intNumSeriales,
                strNumDoc, strTipoTrn, bodcodigo, artcodigo, strTipoDoc,
                intNumLinea);
            }
          });
      }
    }


  }

  crearNuevosSeriales(intNumSeriales, strNumDoc, strTipoTrn,
    strBodCodigo, strArtCodigo, strTipoDoc, NumLineaDoc) {
    this.trnkardexotrservice.tablaseriales = [];
    this.serialseleccionado = {};
    let numserie = ''
    let color = '';
    let bateria = '';

    for (let fila = 1; fila <= intNumSeriales; fila++) {
      //CDPJ
      if (this.datosArray.length > 0) {
        //numserie = this.datosArray[fila - 1].toString().toUpperCase()
        const dato = this.datosArray[fila - 1]
        numserie = dato.serial?.toUpperCase() || ''
        color = dato.color || '';
        bateria = dato.bateria || '';
      }
      //CDPJ
      const item: InvTrnkardexotr = {};

      item.TRNKARDEXOTR_NUMERO = strNumDoc;
      item.TRNKARDEXOTR_NUMSEC = 0;
      item.COM_CODIGO = '01';
      item.TRNKARDEXOTR_TIPO = strTipoTrn;
      item.BOD_CODIGO = strBodCodigo;
      item.ART_CODIGO = strArtCodigo;
      item.TRNKARDEXOTR_NUMSERIE = numserie;
      item.TRNKARDEXOTR_DIM = '';
      item.TRNKARDEXOTR_TELEFONO = '';
      item.TRNKARDEXOTR_ORIGEN = strTipoDoc;
      item.TRNKARDEXOTR_LINEA = NumLineaDoc;
      item.TRNKARDEXOTR_FECHATRN = '';
      item.NUEVO = true;
      item.TRNKARDEXOTR_PORCEBAT = bateria;
      item.TRNKARDEXOTR_COLOR = color
      if (this.datosArray.length > 0) {
        item.NUMLINEA = true
        item.CLAVE = fila + this.datePipe.transform(new Date(), 'dd/MM/yyyy HH:mm:ss')
      }

      this.listaseriales.push(item);
    }
    this.trnkardexotrservice.tablaseriales = this.listaseriales;
    // this.aggrid.refreshaggrid(this.tablaseriales, this.defaultColDefSeriales.objeto);

  }

  async guardarRegistro() {
    const serialporcebat=this.trnkardexotrservice.tablaseriales.filter(x =>
      (!/^\d+$/.test(x.TRNKARDEXOTR_PORCEBAT) ||  
      this.uitilitariosService.redondear(x.TRNKARDEXOTR_PORCEBAT,2) < 0
      || this.uitilitariosService.redondear(x.TRNKARDEXOTR_PORCEBAT,2) > 100 )
      && isNullOrUndefined(x.TRNKARDEXOTR_PORCEBAT) === false && x.TRNKARDEXOTR_PORCEBAT !== ''
      )
    if (this.trnkardexotrservice.tablaseriales.length > this.detalleseleccionado.ARTCANTIDAD && this.devBoolean === false) {
      this.messageService.add({
        key: 'seriales',
        severity: 'warn',
        summary: 'Información',
        detail: 'El número total de seriales es mayor a la cantidad permitida por el artículo.'
      });
      this.spin = false
      this.botonGuardar = false
      return
    }
    console.log(serialporcebat)
    if (serialporcebat.length > 0) {
      for (const iterator of serialporcebat) {
        this.messageService.add({
          key: 'seriales',
          severity: 'warn',
          summary: 'Información',
          detail: `El serial ${iterator.TRNKARDEXOTR_NUMSERIE} tiene una bateria inválida 
          (${iterator.TRNKARDEXOTR_PORCEBAT}). Debe ser un número entero entre 0 y 100`
        });
      }
      this.spin = false
      this.botonGuardar = false
      return
    }
    try {
      if (this.datosArray.length > 0) {
        //for (const iterator of this.tablaseriales) {
        await this.trnkardexotrservice.eliminarKardexOtrAll(this.detalleseleccionado, this.strNumFact).toPromise()//.subscribe(data => {
        //});
        //}
      }

      if (this.strTipoDoc === 'FACPRO' || this.strTipoDoc === 'NOTREC'
        || this.strTipoDoc === 'INVENT' || this.strTipoDoc === 'DVFVEN') {
        await this.validaEntradaSerial(this.strTipoDoc, this.strNumFact);


      } else if (this.strTipoDoc === 'INVSAL' || this.strTipoDoc === 'VEN'
        || this.strTipoDoc === 'GRE'
        || this.strTipoDoc === 'MANTEGR' || this.strTipoDoc === 'TRF' || this.strTipoDoc === 'VENPTOVTA') {
        await this.validaSalidaSerial(this.strTipoDoc, this.strNumFact);
      } else if (this.strTipoDoc === 'MANTING') {
        /* if (this.strNumFact.length > 0) {
           this.verificarExistenciaArtSalioFac(this.strNumFact);
           if (this.bolverificarExistenciaArtSalioFac === false) {
             bolinsertarSeriales = false;
           }
           this.validaEntradaSerial(this.strTipoDoc, this.strNumFact);
           if (this.bolvalidaEntradaSerial === false) {
             bolinsertarSeriales = false;
           }
           this.validaExistenciaSerialDimEntrada(this.strTipoDoc, this.strNumFact);
           if (this.bolvalidaExistenciaSerialDimEntrada === false) {
             bolinsertarSeriales = false;
           }
         }*/
      } else if (this.strTipoDoc === 'DVFCOM') {
        await this.validaSalidaSerialDvfcom(this.strTipoDoc, this.strNumFact);
      }
    } catch (error) {
      this.messageService.add({
        key: 'seriales',
        severity: 'warn',
        summary: 'Información',
        detail: 'Ocurrio un error al guardar los seriales revise la información'
      });
      this.spin = false
      console.log(error)
      return;
    }


  }

  async metodoinsertar(item) {
    let intFechaDoc: string;
    if (this.strFechaSer.toString().includes('-')) {
      intFechaDoc = this.datePipe.transform(this.strFechaSer, 'dd/MM/yyyy');
    } else {
      intFechaDoc = this.strFechaSer;
    }

    if (this.strTipoDoc === 'FACPRO' || this.strTipoDoc === 'NOTREC') {

      await this.insertarSeriales('COM', this.detalleseleccionado.ARTCODIGO,
        intFechaDoc, this.strNumFact, item);
    } //CDPJ
    else if (this.strTipoDoc === 'TRF') {
      //item.TRNKARDEXOTR_NUMERO = item.TRNKARDEXOTR_NUMERO + '_SA';
      //ingresamos la salida
      // await this.insertarSerialesSA(this.strTipoDoc, this.detalleseleccionado.ARTCODIGO,
      //   intFechaDoc, this.strNumFact, item);
      // //ingresamos la entrada
      // // item.TRNKARDEXOTR_NUMERO = item.TRNKARDEXOTR_NUMERO.toString().replace('_SA', '');
      // // item.BOD_CODIGO = this.strnBoddestino;
      // // item.TRNKARDEXOTR_TIPO = 'EN'
      // await this.insertarSerialesEN(this.strTipoDoc, this.detalleseleccionado.ARTCODIGO,
      //   intFechaDoc, this.strNumFact, item);
      if (this.CNCANRECTR === 1) {
        let bodorigen = item.BOD_CODIGO
        await this.insertarSerialesTransferTmp(this.strTipoDoc, this.detalleseleccionado.ARTCODIGO,
          intFechaDoc, this.strNumFact, item, bodorigen);
        this.messageService.add({
          key: 'seriales',
          severity: 'success',
          summary: 'Información',
          detail: 'Seriales Guardados Correctamente'
        });
      } else {
        let bodorigen = item.BOD_CODIGO
        await this.insertarSerialesTransfer(this.strTipoDoc, this.detalleseleccionado.ARTCODIGO,
          intFechaDoc, this.strNumFact, item, bodorigen);
        this.messageService.add({
          key: 'seriales',
          severity: 'success',
          summary: 'Información',
          detail: 'Seriales Guardados Correctamente'
        });
      }


    } else if (this.strTipoDoc === 'DVFCOM' || this.strTipoDoc === 'DVFVEN') {
      if (item.SELECCIONADO) {
        await this.insertarSeriales(this.strTipoDoc, this.detalleseleccionado.ARTCODIGO,
          intFechaDoc, this.strNumFact, item);
      }

    }
    else {
      await this.insertarSeriales(this.strTipoDoc, this.detalleseleccionado.ARTCODIGO,
        intFechaDoc, this.strNumFact, item);
    }

  }

  async validaEntradaSerial(strTipoDoc, strNumFact) {
    let strActivarSerial = 'N';
    let strActivarDim = 'N';
    let strActivarNumeroTel = 'N';
    const res5 = await this.trnkardexotrservice.validarDatosArticulo(this.detalleseleccionado.ARTCODIGO).toPromise()
    for (const rs of res5) {
      if (rs.ART_ACTIVARSERIAL != null) {
        strActivarSerial = rs.ART_ACTIVARSERIAL;
      }
      if (rs.ART_ACTIVARDIM != null) {
        strActivarDim = rs.ART_ACTIVARDIM;
      }
      if (rs.ART_ACTIVARNUMEROTEL != null) {
        strActivarNumeroTel = rs.ART_ACTIVARNUMEROTEL;
      }
    }
    for (let fila = 1; fila <= this.trnkardexotrservice.tablaseriales.length; fila++) {
      let item: InvTrnkardexotr;
      let intExistencia = 0;
      let intExistencia2 = 0;
      let intExistencia3 = 0;
      let intExistencia4 = 0;

      item = this.trnkardexotrservice.tablaseriales[fila - 1];
      if (item.NUEVO === false || ((this.strTipoDoc === 'DVFCOM' || this.strTipoDoc === 'DVFVEN') && item.SELECCIONADO === false)) {

      } else {
        if (item.TRNKARDEXOTR_DIM === null) {
          item.TRNKARDEXOTR_DIM = '';
        }
        const res1 = await this.trnkardexotrservice.esExisteSerial(item.TRNKARDEXOTR_NUMSERIE, item.ART_CODIGO).toPromise()//.subscribe(async res => {
        const res2 = await this.trnkardexotrservice.esvalExisteSerial(strTipoDoc, this.strNumFact, item).toPromise()
        const res3 = await this.trnkardexotrservice.validExistSerDimEntradCu5(strTipoDoc, this.strNumFact, item).toPromise()
        const res4 = await this.trnkardexotrservice.valiExistSerDimEntradaCu(strTipoDoc, this.strNumFact, item).toPromise()

        if (res1 !== null) {
          for (const rs of res1) {
            intExistencia = rs.SERIAL;
          }
        }
        if (res2 !== null) {
          for (const rs of res2) {
            intExistencia2 = rs.SERIAL;
          }
        }
        if (res3 !== null) {
          for (const rs of res3) {
            intExistencia3 = rs.SERIAL;
          }
        }
        if (res4 !== null) {
          for (const rs of res3) {
            intExistencia4 = rs.SERIAL;
          }
        }
        if (intExistencia === 1) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'El Número de Serie ya Existe.'
          });
          this.spin = false
          this.botonGuardar = false
          return;
        }
        if (intExistencia2 === 1) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'El Número de Serie ya Existe.'
          });
          this.spin = false;
          this.botonGuardar = false;
          return;
        }
        if (intExistencia3 === 1) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'El Número de Serie ya Existe'
          });
          this.spin = false
          this.botonGuardar = false
          return;
        }
        if (intExistencia4 === 1) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Dim ya Existe.'
          });
          this.spin = false
          this.botonGuardar = false
          return;
        }
        if (item.TRNKARDEXOTR_NUMSERIE === null) {
          item.TRNKARDEXOTR_NUMSERIE = '';
        }
        if (item.TRNKARDEXOTR_DIM === null) {
          item.TRNKARDEXOTR_DIM = '';
        }
        if (item.TRNKARDEXOTR_TELEFONO === null) {
          item.TRNKARDEXOTR_TELEFONO = '';
        }

        if (item.TRNKARDEXOTR_NUMSERIE.length === 0) {
          if (strActivarSerial === 'S') {
            this.messageService.add({
              key: 'seriales',
              severity: 'warn',
              summary: 'Información',
              detail: 'Ingrese el número de Serie.'
            });
            this.bolvalidarDatos = false;
            this.spin = false
            this.botonGuardar = false
            return;
          }
        }

        if (item.TRNKARDEXOTR_DIM.length === 0) {
          if (strActivarDim === 'S') {
            this.messageService.add({
              key: 'seriales',
              severity: 'warn',
              summary: 'Información',
              detail: 'Ingrese el número de Sim.'
            });
            this.bolvalidarDatos = false;
            this.spin = false
            this.botonGuardar = false
            return;
          }
        }

        if (item.TRNKARDEXOTR_TELEFONO != null
          && item.TRNKARDEXOTR_TELEFONO.length === 0) {
          if (strActivarNumeroTel === 'S') {
            this.messageService.add({
              key: 'seriales',
              severity: 'warn',
              summary: 'Información',
              detail: 'Ingrese el número de Teléfono.'
            });
            this.bolvalidarDatos = false;
            this.spin = false
            this.botonGuardar = false
            return;
          }
        }
      }
    }

    for (let fila = 1; fila <= this.trnkardexotrservice.tablaseriales.length; fila++) {
      let item: InvTrnkardexotr;
      item = this.trnkardexotrservice.tablaseriales[fila - 1];
      if (item.NUEVO === true) {
        await this.metodoinsertar(item)
      }

    }
    this.spin = false
    this.mostrarSerialesGrilla(this.strTipoDoc, this.detalleseleccionado);
  }

  async validaExistenciaSerialDimEntrada(strTipoDoc, strNumDoc, item) {//ya no se usa
    let intExistencia = 0;

    this.trnkardexotrservice.esvalExisteSerial(strTipoDoc, strNumDoc, item).subscribe(async res => {
      for (const rs of res) {
        intExistencia = rs.SERIAL;

        if (intExistencia === 1) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'El Número de Serie ya Existe.'
          });
          this.spin = false
          this.botonGuardar = false
        } else {
          await this.validaExistenciaSerialDimEntradaCu(strTipoDoc, strNumDoc, item);
        }
      }
    });

  }

  async validaSalidaSerial(strTipoDoc, strNumFact) {
    //let intExistencia = 0;
    let strActivarSerial = 'N';
    let strActivarDim = 'N';
    let strActivarNumeroTel = 'N';
    const res8 = await this.trnkardexotrservice.validarDatosArticulo(this.detalleseleccionado.ARTCODIGO).toPromise()
    for (const rs of res8) {
      if (rs.ART_ACTIVARSERIAL != null) {
        strActivarSerial = rs.ART_ACTIVARSERIAL;
      }
      if (rs.ART_ACTIVARDIM != null) {
        strActivarDim = rs.ART_ACTIVARDIM;
      }
      if (rs.ART_ACTIVARNUMEROTEL != null) {
        strActivarNumeroTel = rs.ART_ACTIVARNUMEROTEL;
      }
    }
    for (let fila = 1; fila <= this.trnkardexotrservice.tablaseriales.length; fila++) {
      let item: InvTrnkardexotr;
      item = this.trnkardexotrservice.tablaseriales[fila - 1];
      if (item.TRNKARDEXOTR_DIM === null) {
        item.TRNKARDEXOTR_DIM = '';
      }
      let intExistencia = 0;
      let intExistencia2 = 0;
      let intExistencia4 = 0;
      let intExistencia6 = 0;
      if (item.NUEVO === false) {

      } else {
        if (this.strTipoDoc === 'DVFCOM') {

        } else {

        }
        const res1 = await this.trnkardexotrservice.esvalSalidaSerial(item.TRNKARDEXOTR_NUMSERIE, item.ART_CODIGO, item.BOD_CODIGO).toPromise()//.subscribe(async (res) => {
        const res2 = await this.trnkardexotrservice.esvalidaExistenciaSerialDimSalida(strTipoDoc, this.strNumFact, item).toPromise()
        const res3 = await this.trnkardexotrservice.esValiexiserialdimsal(item.ART_CODIGO, item.TRNKARDEXOTR_NUMSERIE).toPromise()
        const res4 = await this.trnkardexotrservice.esValExisciaSerDimSalCu(strTipoDoc, this.strNumFact, item).toPromise()
        const res5 = await this.trnkardexotrservice.esVaExisciaSerDiSalCu2(item.ART_CODIGO, item.TRNKARDEXOTR_NUMSERIE).toPromise()
        const res6 = await this.trnkardexotrservice.esVaExsciaSerDiSalCu3(strTipoDoc, this.strNumFact, item).toPromise()
        const res7 = await this.trnkardexotrservice.esValExsciaSerDiSalCu4(item.ART_CODIGO, item.TRNKARDEXOTR_NUMSERIE).toPromise()

        if (res1 !== null) {
          for (const rs of res1) {
            intExistencia = rs.SERIAL;
          }
        }
        if (res2 !== null) {
          for (const rs of res1) {
            intExistencia2 = rs.SERIAL;
          }
        }
        if (res4 !== null) {
          for (const rs of res1) {
            intExistencia4 = rs.SERIAL;
          }
        }
        if (res6 !== null) {
          for (const rs of res1) {
            intExistencia6 = rs.SERIAL;
          }
        }
        if (intExistencia === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'No existe serial.'
          });
          this.spin = false
          this.botonGuardar = false
          return;
        }
        if (intExistencia2 === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Serie No está disponible.'
          });
          this.spin = false
          this.botonGuardar = false
          return;
        }
        if (res3.length === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Serie no corresponde al artículo.'
          });
          this.spin = false
          this.botonGuardar = false
          return
        }
        if (intExistencia4 === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Serie No está disponible.'
          });
          this.spin = false
          this.botonGuardar = false
          return
        }
        if (res5.length === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Serie no corresponde al artículo.'
          });
          this.spin = false
          this.botonGuardar = false
          return
        }
        if (intExistencia6 === 0 && item.TRNKARDEXOTR_DIM.length > 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Dim No está disponible.'
          });
          this.spin = false
          this.botonGuardar = false
          return
        }
        if (res7.length === 0 && item.TRNKARDEXOTR_DIM.length > 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Dim no corresponde al artículo.'
          });
          this.spin = false
          this.botonGuardar = false
          return
        }
        if (item.TRNKARDEXOTR_NUMSERIE === null) {
          item.TRNKARDEXOTR_NUMSERIE = '';
        }
        if (item.TRNKARDEXOTR_DIM === null) {
          item.TRNKARDEXOTR_DIM = '';
        }
        if (item.TRNKARDEXOTR_TELEFONO === null) {
          item.TRNKARDEXOTR_TELEFONO = '';
        }

        if (item.TRNKARDEXOTR_NUMSERIE.length === 0) {
          if (strActivarSerial === 'S') {
            this.messageService.add({
              key: 'seriales',
              severity: 'warn',
              summary: 'Información',
              detail: 'Ingrese el número de Serie.'
            });
            this.bolvalidarDatos = false;
            this.spin = false
            this.botonGuardar = false
            return;
          }
        }

        if (item.TRNKARDEXOTR_DIM.length === 0) {
          if (strActivarDim === 'S') {
            this.messageService.add({
              key: 'seriales',
              severity: 'warn',
              summary: 'Información',
              detail: 'Ingrese el número de Sim.'
            });
            this.bolvalidarDatos = false;
            this.spin = false
            this.botonGuardar = false
            return;
          }
        }

        if (item.TRNKARDEXOTR_TELEFONO != null
          && item.TRNKARDEXOTR_TELEFONO.length === 0) {
          if (strActivarNumeroTel === 'S') {
            this.messageService.add({
              key: 'seriales',
              severity: 'warn',
              summary: 'Información',
              detail: 'Ingrese el número de Teléfono.'
            });
            this.bolvalidarDatos = false;
            this.spin = false
            this.botonGuardar = false
            return;
          }
        }
      }
    }
    for (let fila = 1; fila <= this.trnkardexotrservice.tablaseriales.length; fila++) {
      let item: InvTrnkardexotr;
      item = this.trnkardexotrservice.tablaseriales[fila - 1];
      if (item.NUEVO === true) {
        await this.metodoinsertar(item)
      }

    }
    this.spin = false
    this.mostrarSerialesGrilla(this.strTipoDoc, this.detalleseleccionado);
  }
  async validaSalidaSerialDvfcom(strTipoDoc, strNumFact) {
    let strActivarSerial = 'N';
    let strActivarDim = 'N';
    let strActivarNumeroTel = 'N';
    const res8 = await this.trnkardexotrservice.validarDatosArticulo(this.detalleseleccionado.ARTCODIGO).toPromise()
    for (const rs of res8) {
      if (rs.ART_ACTIVARSERIAL != null) {
        strActivarSerial = rs.ART_ACTIVARSERIAL;
      }
      if (rs.ART_ACTIVARDIM != null) {
        strActivarDim = rs.ART_ACTIVARDIM;
      }
      if (rs.ART_ACTIVARNUMEROTEL != null) {
        strActivarNumeroTel = rs.ART_ACTIVARNUMEROTEL;
      }
    }
    for (let fila = 1; fila <= this.trnkardexotrservice.tablaseriales.length; fila++) {
      let item: InvTrnkardexotr;
      item = this.trnkardexotrservice.tablaseriales[fila - 1];
      if (item.TRNKARDEXOTR_DIM === null) {
        item.TRNKARDEXOTR_DIM = '';
      }
      let intExistencia = 0;
      let intExistencia2 = 0;
      let intExistencia4 = 0;
      let intExistencia6 = 0;
      if (item.NUEVO === false) {

      } else if (item.SELECCIONADO === true) {

        const res1 = await this.trnkardexotrservice.esvalSalidaSerial(item.TRNKARDEXOTR_NUMSERIE, item.ART_CODIGO, item.BOD_CODIGO).toPromise()//.subscribe(async (res) => {
        const res2 = await this.trnkardexotrservice.esvalidaExistenciaSerialDimSalida(strTipoDoc, this.strNumFact, item).toPromise()
        const res3 = await this.trnkardexotrservice.esValiexiserialdimsal(item.ART_CODIGO, item.TRNKARDEXOTR_NUMSERIE).toPromise()
        const res4 = await this.trnkardexotrservice.esValExisciaSerDimSalCu(strTipoDoc, this.strNumFact, item).toPromise()
        const res5 = await this.trnkardexotrservice.esVaExisciaSerDiSalCu2(item.ART_CODIGO, item.TRNKARDEXOTR_NUMSERIE).toPromise()
        const res6 = await this.trnkardexotrservice.esVaExsciaSerDiSalCu3(strTipoDoc, this.strNumFact, item).toPromise()
        const res7 = await this.trnkardexotrservice.esValExsciaSerDiSalCu4(item.ART_CODIGO, item.TRNKARDEXOTR_NUMSERIE).toPromise()

        if (res1 !== null) {
          for (const rs of res1) {
            intExistencia = rs.SERIAL;
          }
        }
        if (res2 !== null) {
          for (const rs of res1) {
            intExistencia2 = rs.SERIAL;
          }
        }
        if (res4 !== null) {
          for (const rs of res1) {
            intExistencia4 = rs.SERIAL;
          }
        }
        if (res6 !== null) {
          for (const rs of res1) {
            intExistencia6 = rs.SERIAL;
          }
        }
        if (intExistencia === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'No existe serial.'
          });
          this.spin = false
          this.botonGuardar = false
          return;
        }
        if (intExistencia2 === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Serie No está disponible.'
          });
          this.spin = false
          this.botonGuardar = false
          return;
        }
        if (res3.length === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Serie no corresponde al artículo.'
          });
          this.spin = false
          this.botonGuardar = false
          return
        }
        if (intExistencia4 === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Serie No está disponible.'
          });
          this.spin = false
          this.botonGuardar = false
          return
        }
        if (res5.length === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Serie no corresponde al artículo.'
          });
          this.spin = false
          this.botonGuardar = false
          return
        }
        if (intExistencia6 === 0 && item.TRNKARDEXOTR_DIM.length > 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Dim No está disponible.'
          });
          this.spin = false
          this.botonGuardar = false
          return
        }
        if (res7.length === 0 && item.TRNKARDEXOTR_DIM.length > 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Dim no corresponde al artículo.'
          });
          this.spin = false
          this.botonGuardar = false
          return
        }
        if (item.TRNKARDEXOTR_NUMSERIE === null) {
          item.TRNKARDEXOTR_NUMSERIE = '';
        }
        if (item.TRNKARDEXOTR_DIM === null) {
          item.TRNKARDEXOTR_DIM = '';
        }
        if (item.TRNKARDEXOTR_TELEFONO === null) {
          item.TRNKARDEXOTR_TELEFONO = '';
        }

        if (item.TRNKARDEXOTR_NUMSERIE.length === 0) {
          if (strActivarSerial === 'S') {
            this.messageService.add({
              key: 'seriales',
              severity: 'warn',
              summary: 'Información',
              detail: 'Ingrese el número de Serie.'
            });
            this.bolvalidarDatos = false;
            this.spin = false
            this.botonGuardar = false
            return;
          }
        }

        if (item.TRNKARDEXOTR_DIM.length === 0) {
          if (strActivarDim === 'S') {
            this.messageService.add({
              key: 'seriales',
              severity: 'warn',
              summary: 'Información',
              detail: 'Ingrese el número de Sim.'
            });
            this.bolvalidarDatos = false;
            this.spin = false
            this.botonGuardar = false
            return;
          }
        }

        if (item.TRNKARDEXOTR_TELEFONO != null
          && item.TRNKARDEXOTR_TELEFONO.length === 0) {
          if (strActivarNumeroTel === 'S') {
            this.messageService.add({
              key: 'seriales',
              severity: 'warn',
              summary: 'Información',
              detail: 'Ingrese el número de Teléfono.'
            });
            this.bolvalidarDatos = false;
            this.spin = false
            this.botonGuardar = false
            return;
          }
        }
      }
    }
    for (let fila = 1; fila <= this.trnkardexotrservice.tablaseriales.length; fila++) {
      let item: InvTrnkardexotr;
      item = this.trnkardexotrservice.tablaseriales[fila - 1];
      if (item.NUEVO === true) {
        await this.metodoinsertar(item)
      }

    }
    this.spin = false
  }
  validaExistenciaSerialDimSalida(strTipoDoc, strNumDoc, item) {
    let intExistencia = 0;


    this.trnkardexotrservice.esvalidaExistenciaSerialDimSalida(strTipoDoc, strNumDoc, item).subscribe(res => {
      for (const rs of res) {
        intExistencia = rs.SERIAL;

        if (intExistencia === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Serie No está disponible.'
          });
          this.spin = false
          this.botonGuardar = false
        } else {


          this.trnkardexotrservice.esValiexiserialdimsal(item.ART_CODIGO, item.TRNKARDEXOTR_NUMSERIE).subscribe(async data => {
            if (data.length === 0) {
              this.messageService.add({
                key: 'seriales',
                severity: 'warn',
                summary: 'Información',
                detail: 'Número de Serie no corresponde al artículo.'
              });
              this.spin = false
              this.botonGuardar = false
            } else {
              await this.ValidaExistenciaSerialDimSalidaCu(strTipoDoc, strNumDoc, item);
            }
          });
        }
      }
    });
  }

  verificarExistenciaArtSalioFac(strNumFact): boolean {
    return false;

  }

  ValidaExistenciaSerialDimSalidaCu(strTipoDoc, strNumDoc, item) {
    let strSentencia = '';
    let intExistencia = 0;
    let strSql = '';
    const strBodOrigen = '';

    this.trnkardexotrservice.esValExisciaSerDimSalCu(strTipoDoc, strNumDoc, item).subscribe(res => {
      for (const rs of res) {
        intExistencia = rs.SERIAL;

        if (intExistencia === 0) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'Número de Serie No está disponible.'
          });
          this.spin = false
          this.botonGuardar = false
        } else {

          this.trnkardexotrservice.esVaExisciaSerDiSalCu2(item.ART_CODIGO, item.TRNKARDEXOTR_NUMSERIE).subscribe(async data => {
            if (data.length === 0) {
              this.messageService.add({
                key: 'seriales',
                severity: 'warn',
                summary: 'Información',
                detail: 'Número de Serie no corresponde al artículo.'
              });
              this.spin = false
              this.botonGuardar = false
            } else {
              // verifica existencia del dim
              if (item.TRNKARDEXOTR_DIM === null) {
                item.TRNKARDEXOTR_DIM = '';
              }
              if (item.TRNKARDEXOTR_DIM.length > 0) {

                this.trnkardexotrservice.esVaExsciaSerDiSalCu3(strTipoDoc, strNumDoc, item).subscribe(async res2 => {
                  for (const rs2 of res2) {
                    intExistencia = rs2.SERIAL;

                    if (intExistencia === 0) {
                      this.messageService.add({
                        key: 'seriales',
                        severity: 'warn',
                        summary: 'Información',
                        detail: 'Número de Dim No está disponible.'
                      });
                      this.spin = false
                      this.botonGuardar = false
                    } else {

                      this.trnkardexotrservice.esValExsciaSerDiSalCu4(item.ART_CODIGO, item.TRNKARDEXOTR_NUMSERIE).subscribe(async data2 => {
                        if (data2.length === 0) {
                          this.messageService.add({
                            key: 'seriales',
                            severity: 'warn',
                            summary: 'Información',
                            detail: 'Número de Dim no corresponde al artículo.'
                          });
                          this.spin = false
                          this.botonGuardar = false
                        } else {
                          console.log('ingreso');

                          await this.metodoinsertar(item);
                        }
                      });
                    }
                  }
                });
              } else {
                await this.metodoinsertar(item);
              }
            }
          });
        }
      }
      this.spin = false

    });
  }

  async validaExistenciaSerialDimEntradaCu(strTipoDoc, strNumDoc, item) {
    let strSentencia = '';
    let intExistencia = 0;
    let strSql = '';
    const strBodOrigen = '';

    this.trnkardexotrservice.validExistSerDimEntradCu5(strTipoDoc, strNumDoc, item).subscribe(async res => {
      for (const rs of res) {
        intExistencia = rs.SERIAL;

        if (intExistencia === 1) {
          this.messageService.add({
            key: 'seriales',
            severity: 'warn',
            summary: 'Información',
            detail: 'El Número de Serie ya Existe'
          });
          this.spin = false
          this.botonGuardar = false
        } else {

          if (item.TRNKARDEXOTR_DIM === null) {
            item.TRNKARDEXOTR_DIM = '';
          }
          if (item.TRNKARDEXOTR_DIM.length > 0) {

            this.trnkardexotrservice.valiExistSerDimEntradaCu(strTipoDoc, strNumDoc, item).subscribe(async res2 => {
              for (const rs2 of res2) {
                intExistencia = rs2.SERIAL;

                if (intExistencia === 0) {
                  this.messageService.add({
                    key: 'seriales',
                    severity: 'warn',
                    summary: 'Información',
                    detail: 'Número de Dim ya Existe.'
                  });
                  this.spin = false
                  this.botonGuardar = false
                } else {
                  await this.metodoinsertar(item);
                }
              }
            });
          } else {
            await this.metodoinsertar(item);
          }
        }
      }
      this.spin = false

    });
  }

  validarDatos(strArtCodigo) {
    this.bolvalidarDatos = true;
    let strActivarSerial = 'N';
    let strActivarDim = 'N';
    let strActivarNumeroTel = 'N';

    // Obligar el ingreso del serial, dim o teléfono si en la ficha del
    // artículo está activado
    for (let i = 0; i < 1; i++) {


      this.trnkardexotrservice.validarDatosArticulo(strArtCodigo).subscribe(res => {
        for (const rs of res) {
          if (rs.ART_ACTIVARSERIAL != null) {
            strActivarSerial = rs.ART_ACTIVARSERIAL;
          }
          if (rs.ART_ACTIVARDIM != null) {
            strActivarDim = rs.ART_ACTIVARDIM;
          }
          if (rs.ART_ACTIVARNUMEROTEL != null) {
            strActivarNumeroTel = rs.ART_ACTIVARNUMEROTEL;
          }
        }

        for (let fila = 1; fila <= this.trnkardexotrservice.tablaseriales.length; fila++) {
          let item: InvTrnkardexotr;
          item = this.trnkardexotrservice.tablaseriales[fila - 1];

          if (item.TRNKARDEXOTR_NUMSERIE === null) {
            item.TRNKARDEXOTR_NUMSERIE = '';
          }
          if (item.TRNKARDEXOTR_DIM === null) {
            item.TRNKARDEXOTR_DIM = '';
          }
          if (item.TRNKARDEXOTR_TELEFONO === null) {
            item.TRNKARDEXOTR_TELEFONO = '';
          }

          if (item.TRNKARDEXOTR_NUMSERIE.length === 0) {
            if (strActivarSerial === 'S') {
              this.messageService.add({
                key: 'seriales',
                severity: 'warn',
                summary: 'Información',
                detail: 'Ingrese el número de Serie.'
              });
              this.bolvalidarDatos = false;
              this.spin = false
              this.botonGuardar = false
              break;
            }
          }

          if (item.TRNKARDEXOTR_DIM.length === 0) {
            if (strActivarDim === 'S') {
              this.messageService.add({
                key: 'seriales',
                severity: 'warn',
                summary: 'Información',
                detail: 'Ingrese el número de Sim.'
              });
              this.bolvalidarDatos = false;
              this.spin = false
              this.botonGuardar = false
              break;
            }
          }

          if (item.TRNKARDEXOTR_TELEFONO != null
            && item.TRNKARDEXOTR_TELEFONO.length === 0) {
            if (strActivarNumeroTel === 'S') {
              this.messageService.add({
                key: 'seriales',
                severity: 'warn',
                summary: 'Información',
                detail: 'Ingrese el número de Teléfono.'
              });
              this.bolvalidarDatos = false;
              this.spin = false
              this.botonGuardar = false
              break;
            }
          }
        }
      });
    }
  }


  async insertarSeriales(strTipoDoc, strArtCodigo,
    intFechaDoc, strNumDoc, item) {
    //await this.validarDatos(strArtCodigo);
    // if (this.bolvalidarDatos) {
    if (item.TRNKARDEXOTR_NUMSERIE.length > 0
      || item.TRNKARDEXOTR_DIM.length > 0) {
      await this.trnkardexotrservice.insertarKardexOtr(item, strTipoDoc, intFechaDoc).toPromise().catch(e => {
        this.messageService.add({
          key: 'seriales',
          severity: 'error',
          summary: 'Información',
          detail: 'Hubo un error al guardar los seriales'
        });
        this.spin = false
      })//.subscribe(res => {
      this.messageService.add({
        key: 'seriales',
        severity: 'success',
        summary: 'Información',
        detail: 'Seriales Guardados Correctamente'
      });
      //});
      this.habilitarBotones(true, true, false, true);
      //CDPJ
      this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTR_' + this.strTipoDoc,
        item.TRNKARDEXOTR_NUMERO + '/' + item.ART_CODIGO + '/' + item.TRNKARDEXOTR_NUMSERIE
        + '/Color:' + item.TRNKARDEXOTR_COLOR + '/%Bateria:' + item.TRNKARDEXOTR_PORCEBAT, 'I',
        '', '01', '', '', '', '').subscribe();
      //CDPJ
    }
    //}
  }
  //CDPJ
  async insertarSerialesSA(strTipoDoc, strArtCodigo,
    intFechaDoc, strNumDoc, item) {
    this.validarDatos(strArtCodigo);
    if (this.bolvalidarDatos) {
      if (item.TRNKARDEXOTR_NUMSERIE.length > 0
        || item.TRNKARDEXOTR_DIM.length > 0) {
        item.TRNKARDEXOTR_NUMERO = item.TRNKARDEXOTR_NUMERO + '_SA';
        await this.trnkardexotrservice.insertarKardexOtr(item, strTipoDoc, intFechaDoc).toPromise()//.subscribe(res => {
        //});
        this.habilitarBotones(true, true, false, true);
        //CDPJ
        this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTR_' + this.strTipoDoc,
          item.TRNKARDEXOTR_NUMERO + '/' + item.ART_CODIGO + '/' + item.TRNKARDEXOTR_NUMSERIE, 'I',
          '', '01', '', '', '', '').subscribe();
        //CDPJ
      }
    }
  }
  async insertarSerialesEN(strTipoDoc, strArtCodigo,
    intFechaDoc, strNumDoc, item) {
    this.validarDatos(strArtCodigo);
    if (this.bolvalidarDatos) {
      if (item.TRNKARDEXOTR_NUMSERIE.length > 0
        || item.TRNKARDEXOTR_DIM.length > 0) {
        item.TRNKARDEXOTR_NUMERO = item.TRNKARDEXOTR_NUMERO.toString().replace('_SA', '');
        item.BOD_CODIGO = this.strnBoddestino;
        item.TRNKARDEXOTR_TIPO = 'EN'
        await this.trnkardexotrservice.insertarKardexOtr(item, strTipoDoc, intFechaDoc).toPromise()//.subscribe(res => {

        //});
        this.habilitarBotones(true, true, false, true);
        //CDPJ
        this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTR_' + this.strTipoDoc,
          item.TRNKARDEXOTR_NUMERO + '/' + item.ART_CODIGO + '/' + item.TRNKARDEXOTR_NUMSERIE, 'I',
          '', '01', '', '', '', '').subscribe();
        //CDPJ
      }
    }
  }
  async insertarSerialesTransfer(strTipoDoc, strArtCodigo,
    intFechaDoc, strNumDoc, item, bodorigen) {
    if (item.TRNKARDEXOTR_NUMSERIE.length > 0
      || item.TRNKARDEXOTR_DIM.length > 0) {
      item.BOD_CODIGO = this.strnBoddestino;
      await this.trnkardexotrservice.insertarKardexOtrTransfer(item, strTipoDoc, intFechaDoc, bodorigen).toPromise()
      this.habilitarBotones(true, true, false, true);

      this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTR_' + this.strTipoDoc,
        item.TRNKARDEXOTR_NUMERO + '_SA' + '/' + item.ART_CODIGO + '/' + item.TRNKARDEXOTR_NUMSERIE + '/Color:' + item.TRNKARDEXOTR_COLOR + '/%Bateria:' + item.TRNKARDEXOTR_PORCEBAT, 'I',
        '', '01', '', '', '', '').subscribe();
      this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTR_' + this.strTipoDoc,
        item.TRNKARDEXOTR_NUMERO + '/' + item.ART_CODIGO + '/' + item.TRNKARDEXOTR_NUMSERIE + '/Color:' + item.TRNKARDEXOTR_COLOR + '/%Bateria:' + item.TRNKARDEXOTR_PORCEBAT, 'I',
        '', '01', '', '', '', '').subscribe();

    }

  }
  async insertarSerialesTransferTmp(strTipoDoc, strArtCodigo,
    intFechaDoc, strNumDoc, item, bodorigen) {
    //this.validarDatos(strArtCodigo);
    //if (this.bolvalidarDatos) {

    if (item.TRNKARDEXOTR_NUMSERIE.length > 0
      || item.TRNKARDEXOTR_DIM.length > 0) {
      item.BOD_CODIGO = this.strnBoddestino;
      await this.trnkardexotrservice.insertarKardexOtrTransfertmp(item, strTipoDoc, intFechaDoc, bodorigen).toPromise()
      this.habilitarBotones(true, true, false, true);
      //CDPJ
      this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTRTMP_' + this.strTipoDoc,
        item.TRNKARDEXOTR_NUMERO + '_SA' + '/' + item.ART_CODIGO + '/' + item.TRNKARDEXOTR_NUMSERIE + '/Color:' + item.TRNKARDEXOTR_COLOR + '/%Bateria:' + item.TRNKARDEXOTR_PORCEBAT, 'I',
        '', '01', '', '', '', '').subscribe();
      this.auditoriagral.registrarAuditoria('INV_TRNKARDEXOTRTMP_' + this.strTipoDoc,
        item.TRNKARDEXOTR_NUMERO + '/' + item.ART_CODIGO + '/' + item.TRNKARDEXOTR_NUMSERIE + '/Color:' + item.TRNKARDEXOTR_COLOR + '/%Bateria:' + item.TRNKARDEXOTR_PORCEBAT, 'I',
        '', '01', '', '', '', '').subscribe();
      //CDPJ
    }
    //}
  }
  //CDPJ
  seleccionSerial(valor) {

  }

  seleccionarSeriales() {
    if (this.selectAll === true) {
      this.trnkardexotrservice.tablaseriales.map((serial) => {
        serial.SELECCIONADO = true;
      });
      this.aggrid.refreshaggrid(this.trnkardexotrservice.tablaseriales, this.defaultColDefSeriales.objeto);
    } else if (this.selectAll === false) {
      this.trnkardexotrservice.tablaseriales.map((serial) => {
        serial.SELECCIONADO = false;
      });
      this.aggrid.refreshaggrid(this.trnkardexotrservice.tablaseriales, this.defaultColDefSeriales.objeto);
    }
  }

  habilitarBotones(guardar, eliminar,
    cancelar, imprimir) {
    this.botonGuardar = guardar;
    this.botonBorrar = eliminar;
    this.botonRegresar = cancelar;
  }
}

